module.exports = __webpack_public_path__ + "img/figure.ae7cf78b.png";